import { css } from "@emotion/react";
import { styled } from "@mui/material";
import { pxToRem } from "../../design/utils";
import { FlexRowContainer } from "../bits/layout";

export const ResultsHeader = styled(FlexRowContainer)(
  ({ theme }) => css`
    padding-left: ${theme.spacing(1)};
    height: ${pxToRem(30)};
    box-shadow:
      0px 0px 12px -6px rgba(181, 184, 196, 1),
      0px 0px 4px 2px rgba(181, 184, 196, 1),
      0px 0px 0px 0.5px rgba(244, 244, 246, 1),
      0px -6px 12px -2px rgba(255, 255, 255, 1);
    opacity: 1;
    background-color: rgba(224, 224, 230, 1);
    position: sticky;
  `,
);
